<template>
    <div class="embed-video" :class="classes">
        <div class="embed-video__cover" v-show="!showVideo" @click.prevent.stop="showVideo=true">
            <slot></slot>
        </div>
        <div v-if="showVideo" class="embed-responsive" :class="embedClasses">
            <iframe class="embed-responsive-item" allow="autoplay" frameborder="0" allowfullscreen :src="embedUrl"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ratio: {
                type:String,
                default: '16/9'
            },
            url: {
                type: String,
                required: true
            },
            autoplay: {
                type: Boolean,
                default: true
            },
            show: {
                type:Boolean,
                default: false
            },
            inner: Boolean,
        },
        data() {
            return {
                showVideo: this.show
            }
        },
        computed: {
            embedUrl() {
                let res = null;
                for(let source of ['youtube', 'vimeo']) {
                    if(res = this.tryGetEmbed(source)) break;
                }
                return res;
            },
            classes() {
                return {
                    'embed-video--inner': this.inner,
                }
            },
            embedClasses() {
                return {
                    [`embed-responsive-${this.ratio?.replace('/', 'by')}`]: this.ratio && !this.inner,
                }
            }
        },
        methods: {
            tryGetEmbed(source) {
                let capitalizedSource = source.charAt(0).toUpperCase() + source.slice(1);
                return this[`tryGetEmbed${capitalizedSource}`]();
            },
            tryGetEmbedYoutube() {
                let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                let match = this.url.match(regExp);

                return match && match[2].length === 11
                    ? `https://www.youtube.com/embed/${match[2]}?${this.getParams({ extras:['rel=0'] })}`
                    : false;
            },
            tryGetEmbedVimeo() {
                let regExp = /^.*(vimeo.com\/|vimeo.com\/album\/\d+\/video\/)(\d+).*/;
                let match = this.url.match(regExp);
                return match
                    ? `https://player.vimeo.com/video/${match[2]}?${this.getParams()}`
                    : false;
            },
            getParams({ autoplayKey='autoplay', extras }={}) {
                let params = [];
                this.autoplay && params.push(`${autoplayKey}=1`);
                if(Array.isArray(extras)) {
                    params = [...params, ...extras];
                }
                return params.join('&');
            }
        },
        mounted() {
            if(!this.$slots.default) {
                this.showVideo = true;
            }
        }
    }
</script>